<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="id"
          class="elevation-1"
          :item-class="getRowColor"
        >
          <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
          <template v-slot:item.data="{ item }">
            {{ formatDate(item.data) }}
          </template>

          <template v-slot:item.status="{ item }">
            {{ item.status == 1 ? 'Ativo' : 'Inativo' }}
          </template>

          <template v-slot:item.dias="{ item }">
            {{ diffDays(item.data.split(' ')[0]) }}
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} usuários</span
            >
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
    ultimaAtualizacao: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Último acesso',
          align: 'start',
          filterable: false,
          value: 'data',
          sortable: false,
        },
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'nome',
          sortable: false,
        },
        {
          text: 'Perfil',
          align: 'start',
          filterable: false,
          value: 'funcao',
          sortable: true,
        },
        {
          text: 'Status',
          align: 'start',
          filterable: false,
          value: 'status',
          sortable: true,
        },
        {
          text: 'Quant. de dias do último acesso',
          align: 'center',
          filterable: false,
          value: 'dias',
          sortable: false,
        },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return this.diffDays(item.data.split(' ')[0]) > 30
        ? 'table-row-color-red'
        : ''
    },
  },
}
</script>

<style></style>
